export default __webpack_public_path__ + "static/media/Mike_Rogers.826ae691.jpg";